// 채팅 상태 (3-store). 값을 바꾸는 함수는 이 파일에만 있다.
export const BUBBLE_SEC = 4, LOG_SEC = 12;   // 머리 위 말풍선이 떠 있는 시간, 화면 아래 최근 대화가 사라지기까지 시간(채팅창이 닫혀 있을 때)
export type Bubble = { text: string; t: number };
export type LogLine = { name: string; text: string; at: number; mine: boolean };
// open = 입력칸에 포커스가 있나, vis = 채팅창이 보이나, bubbles: id('me' 또는 서버 접속 id) → 말풍선, log: 최근 대화(캔버스에 잠깐 그린다)
export const CHAT: { open: boolean; vis: boolean; log: LogLine[]; bubbles: Map<string, Bubble>; now: number } = { open: false, vis: false, log: [], bubbles: new Map(), now: 0 };
export function pushLine(name: string, text: string, mine: boolean) { CHAT.log.push({ name, text, at: CHAT.now, mine }); if (CHAT.log.length > 4) CHAT.log.shift(); }
export function setBubble(id: string, text: string) { CHAT.bubbles.set(id, { text, t: BUBBLE_SEC }); }
export function dropBubble(id: string) { CHAT.bubbles.delete(id); }
export function setChatVis(open: boolean, vis: boolean) { CHAT.open = open; CHAT.vis = vis; }
export function tickChat(dt: number) { CHAT.now += dt; for (const [id, b] of CHAT.bubbles) if ((b.t -= dt) <= 0) CHAT.bubbles.delete(id); }

// 사진 뷰어 (확대 배율과 이동)
export const VIEW = { open: false, z: 1, x: 0, y: 0 };
